module.exports = __webpack_public_path__ + "img/exclamation.7476f171.svg";